var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PropertyConverters, Utils, Watch, CustomElementUtils } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
export var ChangePolicy;
(function (ChangePolicy) {
    ChangePolicy["Input"] = "input";
    ChangePolicy["Blur"] = "blur";
})(ChangePolicy || (ChangePolicy = {}));
const INPUT_FIELD_ACTIVATED_PROP = 'pacem:scaffolding:input_field';
export class PacemBaseInputElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this.debounce = false;
        this.changePolicy = ChangePolicy.Input;
        this._focusHandler = (evt) => {
            if (!this.autoselect) {
                return;
            }
            let field = /* first field (usually the only one) */ this.inputField;
            for (let f of this.inputFields ?? []) {
                if (f === document.activeElement) {
                    field = f;
                    break;
                }
            }
            field?.select();
        };
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'placeholder':
                for (let inputField of this.inputFields ?? []) {
                    inputField.setAttribute(name, val);
                }
                break;
        }
    }
    acceptValue(val) {
        if (this.inputField && val !== this.inputField.value) {
            this.inputField.value = Utils.isNullOrEmpty(val) ? '' : val;
        }
    }
    get inputField() {
        return this.inputFields[0];
    }
    onChange(evt) {
        return new Promise((resolve) => {
            if (this.readonly) {
                resolve(this.value);
            }
            else if (evt.type === 'input' && this.changePolicy === ChangePolicy.Blur) {
                resolve(this.value);
            }
            else {
                //
                const fn = () => {
                    const val = this.getValue(this.inputField.value);
                    if (val !== this.value) {
                        this.value = val;
                        // /* DO NOT MESS THE change EVENT DISPATCH */ this.dispatchEvent(new Event('change'));
                    }
                    resolve(val);
                };
                const d = this.debounce;
                if (typeof d === 'number' && d > 0) {
                    clearTimeout(this._handle);
                    this._handle = setTimeout(fn, d);
                }
                else if (d === true) {
                    cancelAnimationFrame(this._handle);
                    this._handle = requestAnimationFrame(fn);
                }
                else
                    requestAnimationFrame(fn);
            }
        });
    }
    ;
    registerInputFields(inputFields = this.inputFields) {
        super.registerInputFields(inputFields);
        if (!Utils.isNull(inputFields) && !Utils.isArray(inputFields)) {
            inputFields = [inputFields];
        }
        for (let field of inputFields ?? []) {
            if (!(field instanceof HTMLInputElement) && !(field instanceof HTMLTextAreaElement)) {
                continue;
            }
            if (CustomElementUtils.getAttachedPropertyValue(field, INPUT_FIELD_ACTIVATED_PROP, 'off') === 'on') {
                continue;
            }
            CustomElementUtils.setAttachedPropertyValue(field, INPUT_FIELD_ACTIVATED_PROP, 'on');
            if ('size' in field) {
                // HTMLInputElement only
                field.size = 1;
            }
            field.autocomplete = 'off';
            field.addEventListener('input', this.changeHandler, false);
            field.addEventListener('focus', this._focusHandler, false);
        }
    }
    unregisterInputFields(inputFields = this.inputFields) {
        super.unregisterInputFields(inputFields);
        if (!Utils.isNull(inputFields) && !Utils.isArray(inputFields)) {
            inputFields = [inputFields];
        }
        for (let field of inputFields ?? []) {
            if (CustomElementUtils.getAttachedPropertyValue(field, INPUT_FIELD_ACTIVATED_PROP) !== 'on') {
                continue;
            }
            CustomElementUtils.deleteAttachedPropertyValue(field, INPUT_FIELD_ACTIVATED_PROP);
            field.removeEventListener('input', this.changeHandler, false);
            field.removeEventListener('focus', this._focusHandler, false);
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.registerInputFields();
    }
    disconnectedCallback() {
        this.unregisterInputFields();
        super.disconnectedCallback();
    }
}
__decorate([
    Watch({
        emit: false, converter: {
            convert: (attr) => {
                switch (attr) {
                    case 'true':
                        return true;
                    case 'false':
                        return false;
                    default:
                        return parseFloat(attr);
                }
            },
            convertBack: (prop) => prop.toString()
        }
    })
], PacemBaseInputElement.prototype, "debounce", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBaseInputElement.prototype, "changePolicy", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemBaseInputElement.prototype, "autoselect", void 0);
export class PacemOrdinalInputElement extends PacemBaseInputElement {
    convertValueAttributeToProperty(attr) {
        return parseFloat(attr);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'min':
            case 'max':
            case 'step':
                val != null ? this.inputField.setAttribute(name, val) : this.inputField.removeAttribute(name);
                break;
        }
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemOrdinalInputElement.prototype, "min", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemOrdinalInputElement.prototype, "max", void 0);
__decorate([
    Watch({
        converter: {
            convert: (attr) => {
                const num = parseFloat(attr);
                return isNaN(num) ? 'any' : num;
            },
            convertBack: (val) => val.toString()
        }
    })
], PacemOrdinalInputElement.prototype, "step", void 0);
export class PacemTextualInputElement extends PacemBaseInputElement {
    convertValueAttributeToProperty(attr) {
        return attr;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'pattern':
            case 'maxlength':
            case 'minlength':
                val != null ? this.inputField.setAttribute(name, val) : this.inputField.removeAttribute(name);
                break;
        }
    }
    getValue(val) {
        return Utils.isNullOrEmpty(val) ? null : val;
    }
    getViewValue(val) {
        return val;
    }
}
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemTextualInputElement.prototype, "pattern", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemTextualInputElement.prototype, "minlength", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemTextualInputElement.prototype, "maxlength", void 0);
